import { reactify } from '@zeiss/zui-react';
export const ZuiIconMedLaserPatternMatrix = reactify('zui-icon-med-laser-pattern-matrix');
